import authAxios from "../common/authAxios";

class StudentAffairsService {
  // Проверка дедлайна
  async checkApplicationDeadline() {
    // Если прошел дедлайн, то вернется false
    return await authAxios.get("/dormitory/check-application-deadline");
  }

  // 1 этап
  async getApplicationsFromFirstStep(
    page,
    gender,
    hasVaccinationPassport,
    privilege,
    fio
  ) {
    const applicationYear = localStorage.getItem("AdmissionOfYear");
    return await authAxios.get(
      `/dormitory/select-applications-from-first-step?page=${page}&application_year=${applicationYear}&gender=${gender}&vaccinationPassport=${hasVaccinationPassport}&privilege_id=${privilege}&fio=${fio}`
    );
  }

  async moveToSecondStep(userId) {
    return await authAxios.put(
      `/dormitory/move-to-second-step?user_id=${userId}`
    );
  }

  async removeFromFirstStep(userId) {
    return await authAxios.put(
      `/dormitory/remove-from-first-step?user_id=${userId}`
    );
  }

  async addCommentToApplication(applicationId, comment) {
    return await authAxios.post(`/dormitory/add-comment`, null, {
      params: { applicationId, comment }
    });
  }


  // 2 этап
  async getApplicationsFromSecondStep(
    page,
    gender,
    hasVaccinationPassport,
    privilege,
    fio
  ) {
    const applicationYear = localStorage.getItem("AdmissionOfYear");
    return await authAxios.get(
      `/dormitory/select-applications-from-second-step?page=${page}&application_year=${applicationYear}&gender=${gender}&vaccinationPassport=${hasVaccinationPassport}&privilege_id=${privilege}&fio=${fio}`
    );
  }

  async acceptApplication(userId) {
    return await authAxios.put(
      `/dormitory/accept-application?user_id=${userId}`
    );
  }

  async getApplicationsAsExcel(stage, gender) {
    const applicationYear = localStorage.getItem("AdmissionOfYear");
    return await authAxios.get(
      `/dormitory/get-excel-students?stage=${stage}&application_year=${applicationYear}&gender=${gender}`,
      { responseType: "blob" }
    );
  }

  async removeFromSecondStep(userId) {
    return await authAxios.put(
      `/dormitory/remove-from-second-step?user_id=${userId}`
    );
  }

  // 3 этап
  async getAcceptedApplications(
    page,
    gender,
    hasVaccinationPassport,
    privilege,
    fio
  ) {
    // if (searchQuery) {
    //   const arr = searchQuery.split(' ');
    //   const [name, surname] = arr;
    //   return await authAxios.get(`/dormitory/select-application-by-fio?name=${name}&surname=${surname}`);
    // }
    const applicationYear = localStorage.getItem("AdmissionOfYear");
    return await authAxios.get(
      `/dormitory/select-applications-from-accepted-students?page=${page}&application_year=${applicationYear}&gender=${gender}&vaccinationPassport=${hasVaccinationPassport}&privilege_id=${privilege}&fio=${fio}`
    );
  }

  async getRefusedApplications(
    page,
    gender,
    hasVaccinationPassport,
    privilege,
    fio
  ) {
    const applicationYear = localStorage.getItem("AdmissionOfYear");
    return await authAxios.get(
      `/dormitory/select-declined-applications?page=${page}&application_year=${applicationYear}&gender=${gender}&vaccinationPassport=${hasVaccinationPassport}&privilege_id=${privilege}&fio=${fio}`
    );
  }


  async revokeApproval(userId) {
    return await authAxios.put(`/dormitory/revoke-approval?user_id=${userId}`);
  }

  async returnToFirstStage(userId) {
    return await authAxios.put(
      `/dormitory/return-to-first-stage?user_id=${userId}`
    );
  }
}

export default StudentAffairsService;
